import { create } from 'zustand';

import { ModalSettings } from 'core/useCases/modal/types';

// État d'UI « modale courante » (quelle modale est ouverte + ses réglages).
// C'est de l'état client pur, donc il vit dans un store zustand plutôt que dans
// Redux. Remplace l'ancien morceau Redux `state.modal.modal` + les actions
// OpenModal / CloseModal (cf. core/useCases/modal/{reducer,modalAction}.ts).
interface ModalState {
    // Reprend la forme exacte de l'ancien state : undefined = aucune modale ouverte.
    modal: ModalSettings | undefined;
    // Remplace dispatch(OpenModal(settings)).
    openModal: (settings: ModalSettings) => void;
    // Remplace dispatch(CloseModal()).
    closeModal: () => void;
}

export const useModalStore = create<ModalState>((set) => ({
    modal: undefined,
    openModal: (settings) => set({ modal: settings }),
    closeModal: () => set({ modal: undefined }),
}));
